import BranchSystemCreate from 'components/shared/BranchSystemCreate/BranchSystemCreate';
import React from 'react';

const ProductBranch = () => {
  return <BranchSystemCreate />;
};

export default ProductBranch;
